const splitStringBySubstrings = (fullText, substrings) => {
  // Add validation
  if (!fullText || typeof fullText !== "string") {
    return [{ text: fullText || "", isSubsection: false }];
  }

  if (!substrings || !Array.isArray(substrings) || substrings.length === 0) {
    return [{ text: fullText, isSubsection: false }];
  }

  const result = [];
  let currentIndex = 0;

  // Filter out empty/invalid substrings and escape regex-sensitive characters
  const escapedSubstrings = substrings
    .filter((str) => str && typeof str === "string" && str.trim().length > 0)
    .map((str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  // If no valid substrings, return original text
  if (escapedSubstrings.length === 0) {
    return [{ text: fullText, isSubsection: false }];
  }

  // Build regex to match any of the substrings
  const pattern = new RegExp(escapedSubstrings.join("|"), "g");

  let match;
  while ((match = pattern.exec(fullText)) !== null) {
    const { index } = match;
    const matchText = match[0];

    // Add text before the match
    if (currentIndex < index) {
      result.push({
        text: fullText.slice(currentIndex, index),
        isSubsection: false,
      });
    }

    // Add the matching highlight
    result.push({
      text: matchText,
      isSubsection: true,
    });

    currentIndex = index + matchText.length;
  }

  // Add any remaining text after the last match
  if (currentIndex < fullText.length) {
    result.push({
      text: fullText.slice(currentIndex),
      isSubsection: false,
    });
  }

  return result;
};

export default splitStringBySubstrings;
